import React, { createContext, useContext, useState} from "react";

const StateContext = createContext();
// object
const initialState = {
    chat: false,
    cart: false,
    userProfile: false,
    notification: false,
}

export const ContextProvider = ({ children}) => {

    const [activeMenu, setActiveMenu] = useState(true);
    const [isClicked, setIsClicked] = useState(initialState);
    const [screenSize, setScreenSize] = useState(undefined);
    const [currentColor, setCurrentColor] = useState('#03C9D7');
    const [currentMode, setCurrentMode] = useState('Light');
    const [themeSettings, setThemeSettings] = useState(false);

    const setMode = (e) => {
        // the mode we clicked
        setCurrentMode(e.target.value);
        localStorage.setItem('themeMode', e.target.value);
    
        setThemeSettings(false);
    };
    
    const setColor = (color) => {
        setCurrentColor(color);
        localStorage.setItem('colorMode', color);
    
        setThemeSettings(false);
    };

    const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });

    return (
        // pass the state through the value, value is an object, when key & value is the same then it can b ommited (activeMenu: activeMenu)
        <StateContext.Provider value={{ activeMenu, setActiveMenu, 
            handleClick, isClicked, initialState, setIsClicked, 
            screenSize, setScreenSize, currentColor, currentMode, 
            themeSettings, setThemeSettings, setColor, setMode }}>
            {children}
        </StateContext.Provider>
    )
}

// for using activeMenu in the components
export const useStateContext = () => useContext(StateContext);
